import { observer } from "@legendapp/state/react";
import { observable } from '@legendapp/state';
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FormInput } from "_components/form";
import { AttendanceSituation, AttendanceSituationOptions } from "_enums/AttendanceSituation";
import { Button } from '_ui/Button';
import { toastRun } from "_utils/misc";
import { useGoBack } from '_utils/url';
import { $currentAttendanceId, $selectedSituation } from '../state';
import { useAttendanceEnd } from "_api/hooks/Client/attendances";
import { apiSwr } from "_api";
import { clientRoutes } from "_api/client-routes";
import { $clientEnded } from "../store";
import { DeskHub } from "_services/ws/desk-hub";
import { $npsOpen } from "./Nps";


const $openAttendanceAskSituation = observable(false);
export const openAskAttendanceSituation = () => {
    $openAttendanceAskSituation.set(true);
}

const hideAskAttendanceSituation = () => {
    $openAttendanceAskSituation.set(false);
}

export const AskSituation = observer(() => {
    const attendanceId = $currentAttendanceId.$!;

    const { mutateAsync: end, isPending: loading } = useAttendanceEnd(attendanceId);
    const back = useGoBack();

    const options = AttendanceSituationOptions;

    const form = useForm({
        defaultValues: {
            situation: AttendanceSituation.Resolved,
        },
    });
    const {
        register,
        control,
        formState: { errors },
    } = form;

    const onSubmit = async () => {
        hideAskAttendanceSituation();
        $selectedSituation.set(form.getValues().situation);
        $npsOpen.set(true);

        // await toastRun(
        //     end(form.getValues()),
        //     () => {
        //         hideAskAttendanceSituation();
        //     }
        // );
    }

    if ($openAttendanceAskSituation.$) {
        apiSwr.invalidateQueries({ queryKey: [...clientRoutes.attendance(attendanceId).show] });
        DeskHub.clearTokens();
        $clientEnded.set(true);
    }

    return (
        <Modal show={$openAttendanceAskSituation.get()} onHide={hideAskAttendanceSituation} backdrop="static">
            <Modal.Header>
                <Modal.Title>
                    Atendimento finalizado
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <FormInput
                    label='Situação da sua solicitação'
                    name='situation'
                    type='select'
                    placeholder='Cívil'
                    containerClass='w-100'
                    {...{ register, errors, control, options }}
                />
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={onSubmit} {...{ loading }} text='Próximo' />
            </Modal.Footer>
        </Modal>
    );
});
